<template>
  <div>
    <div>
      <div class="searchArea">

        <a-select v-model:value="inputs.clubId" placeholder="门店" style="width: 275px;">
          <a-select-option v-for="item in clubList" :value="item.id" :key="item.id">{{ item.name }}</a-select-option>
        </a-select>

        <a-button type="primary" shape="circle" @click="search('')">
          <template #icon>
            <SearchOutlined />
          </template>
        </a-button>
        <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
      </div>
      <a-table class="ant-table-striped" :columns="columns" :data-source="data" :rowClassName="rowClassName" bordered rowKey="id">
        <template #operation="{ record }">
          <div class="flex_sa">
            <div class="editable-row-operations flex_sa" v-if="auth.canEditInfo">
              <span>
                <a @click="edit(record)">信息编辑</a>
              </span>
            </div>

            <div class="editable-row-operations flex_sa" v-if="auth.canManageSchedule">
              <span>
                <a @click="edit2(record)">
                  <span>出诊管理</span>
                </a>
              </span>
            </div>
          </div>
        </template>
        <template v-for="col in ['nameInitial']" #[col]="{ text, record }" :key="col">
          <div>
            <a-input v-if="editableData[record.id]" v-model:value="editableData[record.id][col]" style="margin: -5px 0" />
            <template v-else>{{ text }}</template>
          </div>
        </template>
        <template v-for="col in ['count']" #[col]="{ text, record }" :key="col">
          <div>
            {{ record.appSetting?.defaultScheduleCount }}
          </div>
        </template>
        <template v-for="col in ['scheduleAvailable']" #[col]="{ text, record }" :key="col">
          <div>
            {{ record.appSetting?.scheduleAvailable?'是':'否' }}
          </div>
        </template>
        <template v-for="col in ['recommendIndex']" #[col]="{ text, record }" :key="col">
          <div>
            {{ record.appSetting?.recommendIndex }}
          </div>
        </template>

      </a-table>

    </div>

    <editDoctor v-model="visible" :record="record" @reSearch="search('')" />
    <settingDoctor v-model="visible2" :record="record" @reSearch="search('')" />

  </div>
</template>

<style scoped>
.online {
  background: #40a9ff;
  border-color: #40a9ff;
}

.offline {
  background: #979596;
  border-color: #979596;
}

:deep(.ant-table-tbody > tr > td, .ant-table-thead > tr > th) {
  padding: 10px 8px;
}

.table_btn {
  width: 70px;
  display: inline-block;
  text-align: center;
}

.clickable {
  /* background-color: #000; */
  width: 100%;
  height: 100%;
}
</style>

<script>
import {
  SearchOutlined,
  PlusOutlined,
  DownloadOutlined,
  CheckCircleFilled,
  WarningFilled,
  FormOutlined
} from "@ant-design/icons-vue";
import { reactive } from "vue";
import { cloneDeep } from "lodash-es";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import { Search, EmployeeList, DoctorSetting, EmployeeEdit } from "/src/api/appointment.js";
import { ClubList } from "/src/api/businessManage/summary.js";
import { GetPageOperationList } from "/src/api/sys.js";
import { pinyin } from 'pinyin-pro';
import getAutoPrescription from '/src/components/autoPrescription/getAutoPrescription.vue';
import editDoctor from '/src/components/doctorManage/editDoctor.vue';
import settingDoctor from '/src/components/doctorManage/settingDoctor.vue';

export default {
  components: {
    SearchOutlined,
    PlusOutlined,
    DownloadOutlined,
    locale,
    CheckCircleFilled,
    WarningFilled,
    getAutoPrescription,
    FormOutlined,
    editDoctor,
    settingDoctor
  },
  name: "医生管理",
  data() {
    return {
      modalBtn: "",
      modalIndex: "0",
      clubId: undefined,
      visible: false,
      visible2: false,
      visible3: false,
      visible4: false,
      active: undefined,
      id: undefined,
      selectClubId: undefined,
      selectedRow: {},
      total: 0,
      current: 1,
      // pageSize: 10,
      inputs: {
        name: undefined,
        gender: undefined,
        isStandard: undefined,
        clubId: undefined,
      },
      modelInput: {
        name: undefined,
        gender: undefined,
        nameInitial: undefined,
        isStandard: true,
      },
      auth: {
        canEditInfo: false,      // 对应：操作-出诊管理-信息编辑
        canManageSchedule: false // 对应：操作-出诊管理-出诊管理
      },
      clubList: [],
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      option: [{ value: "黄浦区" }, { value: "浦东新区" }, { value: "长宁区" }],
      columns: [
        {
          title: "编号",
          key: "id",
          dataIndex: "id",
          width: "15%",
          slots: {
            customRender: "id"
          }
        },
        {
          title: "姓名",
          key: "name",
          dataIndex: "name",
          ellipsis: true,
          width: "15%",
          slots: {
            customRender: "name"
          },
        },
        {
          title: "性别",
          width: "15%",
          key: "gender",
          dataIndex: "gender",
          slots: {
            customRender: "gender"
          }
        },
        {
          title: "职称",
          key: "title",
          dataIndex: "title",
          // ellipsis: true,
          width: "15%",
          slots: {
            customRender: "title"
          }
        },
        {
          title: "是否出诊",
          key: "scheduleAvailable",
          dataIndex: "scheduleAvailable",
          width: "15%",
          slots: {
            customRender: "scheduleAvailable"
          }
        },
        {
          title: "推荐指数",
          key: "recommendIndex",
          dataIndex: "recommendIndex",
          ellipsis: true,
          width: "15%",
          slots: {
            customRender: "recommendIndex"
          }
        },
        {
          title: "时段人数",
          key: "count",
          dataIndex: "count",
          ellipsis: true,
          width: "15%",
          slots: {
            customRender: "count"
          }
        },
        {
          title: "操作",
          dataIndex: "operation",
          width: "15%",
          slots: {
            customRender: "operation"
          }
        }
      ],
      data: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(
            `selectedRowKeys: ${selectedRowKeys}`,
            "selectedRows: ",
            selectedRows
          );
          this.selectedRows = selectedRows;
        },
        onSelect: (record, selected, selectedRows) => {
          console.log(record, selected, selectedRows);
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          console.log(selected, selectedRows, changeRows);
        }
      },
      editableData: reactive({}),
      record: {},
      selectClub: undefined,
      rowClassName: (record, index) => {
        let className = (index % 2 === 1 ? 'table-striped' : null)
        if (record?.appSetting?.scheduleAvailable) {
          className = className + ' heightLight'
        }
        return className
      },

      // doExcel: doExcel
    };
  },
  created() { },
  mounted() {
    this.init();
  },
  activated() {
    if (localStorage.getItem("refrashProject") == "true") {
      // this.search(1);
    }
    localStorage.setItem("refrashProject", false);
  },
  methods: {
    init() {
      this.getClubList()
      this.getPageAuth();
    },

    async getClubList() {
      try {
        let res = await ClubList();

        if (res.errCode === 0 && res.data) {
          this.clubList = res.data;

          if (this.clubList.length === 1) {
            this.inputs.clubId = this.clubList[0].id;
            this.search("");
          }
        }
      } catch (error) {
        console.error("获取门店异常:", error);
      }
    },
    async getPageAuth() {
      try {

        const params = {
          name: "页面-出诊管理",
        };

        let res = await GetPageOperationList(params);

        if (res.errCode === 0 && Array.isArray(res.data)) {
          const operations = res.data;

          this.auth.canEditInfo = operations.includes("操作-信息编辑");
          this.auth.canManageSchedule = operations.includes("操作-出诊管理");

          // console.log("当前页面权限状态:", this.auth);
        }
      } catch (error) {
        // 异常处理规范
        console.error("获取页面权限失败:", error);
      }
    },
    showModal() {
      this.visible = true;
    },
    closeModal(value) {
      this[value] = false;
    },
    getAutoPrescription(record) {
      this.visible2 = true
      this.selectedRow = { ...record }
    },
    linkDisease(record) {
      this.visible3 = true
      this.selectedRow = { ...record }
    },
    Detail(record) {
      this.visible4 = true
      this.selectedRow = { ...record }
    },
    async handleOk() {
      let _this = this;

      let res = await Add(this.modelInput)
      if (res.errCode == 0) {
        _this.$message.success("新建成功", function () { });
        _this.visible = false
      }
    },
    resetForm() {
      this.inputs = {
        name: undefined,
        gender: undefined,
        isStandard: undefined,
        clubId: undefined,
      }
    },

    async addDisease() {
      this.visible = true;
    },
    async onDelete(id) {
      this.editableData = {}
      let res = await Delete({ id })
      this.data = this.data.filter(function (item) {
        return item.id !== id;
      });
    },
    edit(record) {
      this.visible = true;
      this.record = { ...record }
    },
    edit2(record) {
      let _record = { ...record }
      _record.clubId = this.selectClubId
      if (!_record.appSetting) {
        _record.appSetting = {
          defaultScheduleCount: 0,
          scheduleAvailable: false
        }
      }
      if (!_record.appSetting?.defaultScheduleCount) {
        _record.appSetting.defaultScheduleCount = 0
      }
      if (!_record.appSetting?.scheduleAvailable) {
        _record.appSetting.scheduleAvailable = false
      }
      this.visible2 = true;
      console.log(_record.recommendIndex);

      this.record = { ..._record }
    },
    async save(id) {
      let _data = this.data;
      //判断editableData和修改前是否一致，如果一致则不修改
      if (JSON.stringify(this.data.find((item) => item.id == id)) === JSON.stringify(this.editableData[id])) {
        delete this.editableData[id];
        return;
      }
      let params = {
        id: this.editableData[id].id,
        name: this.editableData[id].name,
        nameInitial: this.editableData[id].nameInitial,
        gender: this.editableData[id].gender,
      }
      console.log(params);
      let res = await Update(params)
      if (res.errCode == 0) {
        Object.assign(
          _data.filter(item => id === item.id)[0],
          this.editableData[id]
        );
        delete this.editableData[id];
      }
    },
    cancel(id) {
      delete this.editableData[id];
    },
    tabsName(tabName) {
      this.$store.commit("changePage", { name: tabName.name, query: tabName.query });
    },
    async search(pagination) {
      if (!this.inputs.clubId) {
        this.$message.error("请选择门店", function () { });
        return
      }
      let _this = this;
      this.selectedClientAppName = this.inputs.clientAppName
      this.editableData = {}
      // this.currentClientAppName = this.inputs.clientAppName
      let params = {
        clubId: this.inputs.clubId,
        position: "医生",
        includeSchedule: 1
      };
      if (pagination == "") {
        params.current = 1
      } else {
        params.current = pagination.current
        this.current = pagination.current;
      }
      let res = await EmployeeList(params)
      console.log(res);

      if (res.errCode == 0) {
        if (pagination == "") {
          // this.$message.success("查询成功", function () { });
          this.current = 1;
          this.selectClubId = this.inputs.clubId
        }

        this.data = res.data

      } else {
        this.$message.error("查询失败", function () { });
      }
      // this.data = res
    },

  }
};
</script>